<template>
  <v-dialog v-model="dialog" :overlay-opacity="0.7" width="700" scrollable>
    <v-card class="py-2">
      <!-- <v-card-title>
        <v-spacer></v-spacer>
        <v-btn @click="close()" icon>
          <v-icon> mdi-close </v-icon>
        </v-btn>
      </v-card-title> -->
      <v-card-title>
        <SearchField
          v-model="search"
          @search="handleSearch"
          placeholder="Pesquisar"
          autofocus
          :hint="searchHint"
          :hide-details="!!!searchHint"
          persistent-hint
        />
      </v-card-title>
      <v-card-text
        v-if="result || loading"
        style="max-height: calc(100dvh - 100px)"
      >
        <v-card color="#f1f1f1" flat>
          <v-card-text>
            <div v-if="loading">
              <v-skeleton-loader
                type="list-item,list-item,list-item,list-item,list-item"
              ></v-skeleton-loader>
            </div>
            <div v-else-if="result">
              <div v-if="result.leads.length > 0" class="subtitle-2 mb-2">
                Processos
              </div>
              <v-row v-for="lead in result.leads" :key="lead.id" dense>
                <v-col>
                  <ResultCard
                    :to="getLeadRoute(lead.identifier_code)"
                    @click="close"
                    :title="highlight(lead.identifier_code)"
                  >
                    <AttributeSpan
                      icon="mdi-domain"
                      title="Companhia"
                      :text="getCompanyName(lead.insurer_name)"
                      always
                    />
                    <AttributeSpan
                      icon="mdi-domain"
                      title="Número da companhia"
                      :text="highlight(lead.external_reference)"
                      always
                    />
                    <AttributeSpan
                      icon="mdi-account"
                      title="Segurado"
                      :text="lead.insured_name"
                      always
                    />
                    <AttributeSpan
                      icon="mdi-note-edit-outline"
                      title="Apólice"
                      :text="highlight(lead.policy)"
                    />
                  </ResultCard>
                </v-col>
              </v-row>

              <div
                v-if="result.participants.length > 0"
                class="subtitle-2 my-2"
              >
                Lesados
              </div>
              <v-row
                v-for="participant in result.participants"
                :key="`${participant.id}-${participant.participant_id}`"
                dense
              >
                <v-col>
                  <ResultCard
                    :to="getLeadRoute(participant.identifier_code)"
                    @click="close"
                    :title="`${highlight(participant.name)} - ${
                      participant.participant_type
                    }`"
                  >
                    <AttributeSpan
                      icon="mdi-domain"
                      title="Companhia"
                      :text="getCompanyName(participant.insurer_name)"
                      always
                    />
                    <AttributeSpan
                      icon="mdi-pound"
                      title="Processo"
                      :text="highlight(participant.identifier_code)"
                      always
                    />
                    <AttributeSpan
                      icon="mdi-phone"
                      title="Contacto principal"
                      :text="highlight(participant.contact1)"
                    />
                    <AttributeSpan
                      icon="mdi-phone"
                      title="Contacto secundário"
                      :text="highlight(participant.contact2)"
                    />
                    <AttributeSpan
                      icon="mdi-card-account-details"
                      title="NIF"
                      :text="highlight(participant.fiscal_number)"
                    />
                    <AttributeSpan
                      icon="mdi-email"
                      title="Email"
                      :text="highlight(participant.email)"
                    />
                  </ResultCard>
                </v-col>
              </v-row>

              <v-row
                v-if="result.leads.length < 1 && result.participants.length < 1"
                class="my-4"
              >
                <v-col class="text-center">
                  Não encontramos nenhum processo que corresponda à pesquisa
                </v-col>
              </v-row>

              <v-row v-if="result.suggestions.length > 0">
                <v-col>
                  Você quis dizer:
                  <v-chip-group>
                    <v-chip
                      v-for="suggestion in result.suggestions"
                      :key="suggestion.name"
                      @click="handleClickSuggestion(suggestion.name)"
                      small
                      color="white"
                    >
                      {{ suggestion.name }}
                    </v-chip>
                  </v-chip-group>
                </v-col>
              </v-row>
            </div>
          </v-card-text>
        </v-card>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import i18n from "@/mixins/i18n";
import SearchField from "@/components/SearchField.vue";
import { search as httpSearch } from "@/services/search";
import ResultCard from "./AppSearch/ResultCard.vue";
import AttributeSpan from "./AppSearch/AttributeSpan.vue";

export default {
  components: {
    SearchField,
    ResultCard,
    AttributeSpan,
  },

  mixins: [i18n],

  props: {},

  data() {
    return {
      dialog: false,
      search: "",
      loading: false,
      result: null,
    };
  },

  methods: {
    getCompanyName(name) {
      return name.split(" ")[0] || "";
    },

    handleClickSuggestion(suggestion) {
      this.search = suggestion;
    },

    getLeadRoute(lead_number) {
      return { name: "lead_detail_data", params: { lead_number } };
    },

    handleClickLead(lead_number) {
      this.close();
      this.$router.push(this.getLeadRoute(lead_number));
    },

    open() {
      this.dialog = true;
      this.clear();
    },

    close() {
      this.dialog = false;
    },

    clear() {
      this.search = "";
      this.result = null;
    },

    async handleSearch() {
      if (!this.search) {
        this.result = null;
        return;
      }

      if (this.search.length < 3) {
        return;
      }

      this.result = null;

      this.loading = true;
      try {
        const response = await httpSearch(this.search);
        this.result = response.data;

        const singleLead = this.getSingleLead(response.data);
        if (!singleLead) {
          return;
        }

        this.handleClickLead(singleLead);
      } finally {
        this.loading = false;
      }
    },

    getSingleLead(result) {
      if (result.leads.length + result.participants.length !== 1) {
        return null;
      }

      if (result.leads.length === 1) {
        return result.leads[0].identifier_code;
      }

      return result.participants[0].identifier_code;
    },

    normalize(text) {
      return text
        .normalize("NFD")
        .replace(/\p{Diacritic}/gu, "")
        .toLowerCase();
    },

    highlight(text) {
      const term = this.search;

      if (!term?.trim()) {
        return text;
      }

      if (!text?.trim()) {
        return text;
      }

      const normalizedText = this.normalize(text);
      const normalizedTerm = this.normalize(term);

      const start = normalizedText.indexOf(normalizedTerm);

      if (start === -1) {
        return text;
      }

      const end = start + normalizedTerm.length;

      return (
        text.slice(0, start) +
        `<span class='highlight'>${text.slice(start, end)}</span>` +
        text.slice(end)
      );
    },
  },

  computed: {
    searchHint() {
      if (!this.search) {
        return "";
      }

      if (this.search.length > 2) {
        return "";
      }

      return "Digite pelo menos 3 caracteres";
    },
  },
};
</script>

<style lang="scss">
.highlight {
  //   background-color: #00746b;
  color: #00746b;
  font-weight: bold;
}
</style>
